import { setStoreTypeValues } from 'utils/setStoreTypeValues';

let types: any = {
  GET_RULE_CODES_REQUEST: '',
  GET_RULE_CODES_SUCCESS: '',
  GET_RULE_CODES_FAILURE: '',
};

types = setStoreTypeValues(types, 'authRuleCodes');

export default types;
